import $ from 'jquery';
import ProfileStore from 'framework/stores/ProfileStore';
import profileStoreIsAvailable from 'lib/profile-store-utils';

function updateLtbucks(profile) {
	if(profile && profile.memberDetails) {
		var valBucks = profile.memberDetails.ltBucksBalance;
		if(valBucks > 0) {
			$('.bucks-balloon').each(function() {
				var bucksContainerClone = $(this).clone();
				bucksContainerClone.find('span.ltnav-ltbucks').remove();
				var balloon = bucksContainerClone.html() + '<span class="ltnav-ltbucks">' + valBucks + '</span>';
				$(this).html(balloon);
			});
		}
	}
}

function updateContent(profile) {
	profile = profile || ProfileStore.getInitialData();
	$('[data-profile]').each((index, item)=> {
		var element = $(item);
		var profileElement = element.data('profile-property');
		if(profileElement) {
			var property = _.result(profile, profileElement);
			if(property) {
				element.html((element.data('profile-prefix') || '') + property + (element.data('profile-suffix') || ''));
			}
		}
	});

	updateLtbucks(profile);
}

export default updateContent;

if (profileStoreIsAvailable) {
    updateContent();

    ProfileStore.listen(updateContent);
}
